const getIsFieldVisionSupported = (state) => {
    const { enableFieldVision, forceFieldVisionOn } = state.config || {};
    if (!enableFieldVision && !forceFieldVisionOn) {
        return false;
    };
    if (state.gumbo?.gameData?.game?.gamedayType !== 'P') return false;

    const status = state?.gumbo?.gameData?.status || {};
    const { abstractGameCode = '', statusCode,  codedGameState } = status;
    if (abstractGameCode === 'F' || statusCode === 'PW') return false;
    if (codedGameState === 'T' || codedGameState === 'U') return false; //isSuspended
    if (codedGameState === 'I' && (statusCode !== 'I' && statusCode !== 'IH')) return false; //isInGameDelay

    const fieldVisionVenues = state.config?.fieldVisionVenues;
    const venueId = (state.gumbo?.gameData?.venue?.id || '').toString();
    return fieldVisionVenues && fieldVisionVenues.has(venueId);
};

export default getIsFieldVisionSupported;
